<template>
  <div :class="['dq-brand-mark', `dq-brand-mark--${variant}`, `dq-brand-mark--${tone}`]">
    <span class="dq-brand-mark__icon-shell" aria-hidden="true">
      <img
        class="dq-brand-mark__icon"
        :src="payrollIcon"
        alt="HR and payroll"
      />
    </span>

    <div v-if="variant !== 'icon'" class="dq-brand-mark__copy">
      <template v-if="variant === 'sidebar'">
        <span class="dq-brand-mark__eyebrow">DoneQuick</span>
        <span class="dq-brand-mark__title">Hr &amp; Payroll</span>
      </template>
      <template v-else>
        <span class="dq-brand-mark__eyebrow">DoneQuick</span>
        <span class="dq-brand-mark__title">HR &amp; Payroll</span>
      </template>
    </div>
  </div>
</template>

<script>
import payrollIcon from "@/assets/img/icons8-payroll-96.png";

export default {
  props: {
    variant: {
      type: String,
      default: "full",
      validator: (value) => ["full", "compact", "sidebar", "icon"].includes(value),
    },
    tone: {
      type: String,
      default: "light",
      validator: (value) => ["light", "dark"].includes(value),
    },
  },
  data() {
    return {
      payrollIcon,
    };
  },
};
</script>

<style scoped>
.dq-brand-mark {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  max-width: 100%;
  min-width: 0;
}

.dq-brand-mark__icon-shell {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  flex: 0 0 auto;
}

.dq-brand-mark__icon {
  display: block;
  object-fit: contain;
  object-position: left center;
  filter: drop-shadow(0 8px 18px rgba(23, 29, 52, 0.12));
  transform: translateX(-7px) scale(1.16);
  transform-origin: left center;
}

.dq-brand-mark__copy {
  display: flex;
  flex-direction: column;
  line-height: 1;
  min-width: 0;
}

.dq-brand-mark__eyebrow {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  opacity: 0.76;
}

.dq-brand-mark__title {
  font-size: 0.98rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.dq-brand-mark--full .dq-brand-mark__icon-shell {
  width: 36px;
  height: 34px;
}

.dq-brand-mark--full .dq-brand-mark__icon {
  width: 44px;
  height: 44px;
}

.dq-brand-mark--compact .dq-brand-mark__icon-shell {
  width: 31px;
  height: 30px;
}

.dq-brand-mark--compact .dq-brand-mark__icon {
  width: 38px;
  height: 38px;
}

.dq-brand-mark--icon .dq-brand-mark__icon-shell {
  width: 24px;
  height: 24px;
}

.dq-brand-mark--icon .dq-brand-mark__icon {
  width: 30px;
  height: 30px;
}

.dq-brand-mark--sidebar {
  gap: 0.38rem;
}

.dq-brand-mark--sidebar .dq-brand-mark__icon-shell {
  width: 33px;
  height: 32px;
}

.dq-brand-mark--sidebar .dq-brand-mark__icon {
  width: 41px;
  height: 41px;
}

.dq-brand-mark--light {
  color: #171d34;
}

.dq-brand-mark--dark {
  color: #ffffff;
}

.dq-brand-mark--compact .dq-brand-mark__eyebrow {
  font-size: 0.58rem;
  margin-bottom: 0.08rem;
}

.dq-brand-mark--compact .dq-brand-mark__title {
  font-size: 0.8rem;
  line-height: 0.98;
}

.dq-brand-mark--sidebar .dq-brand-mark__eyebrow {
  font-size: 0.66rem;
  margin-bottom: 0.08rem;
}

.dq-brand-mark--sidebar .dq-brand-mark__title {
  font-size: 0.88rem;
  line-height: 0.98;
}

.dq-brand-mark--sidebar .dq-brand-mark__copy {
  justify-content: center;
}

.dq-brand-mark--sidebar .dq-brand-mark__eyebrow {
  font-size: 0.68rem;
  margin-bottom: 0.06rem;
  white-space: nowrap;
}

.dq-brand-mark--sidebar .dq-brand-mark__title {
  font-size: 0.88rem;
  line-height: 0.96;
  white-space: nowrap;
}
</style>
